/**
 * Default Docket Entries Tab
 */

import { axiosRequest } from '@/plugins/axios-common'
import { handleError } from '@/store/handle-error'

export const OtherDocketEntriesSettingsState = {
  defaultDocketEntriesSettings: {},
  defaultDocketEntriesSettingsLoading: false,
}

export const OtherDocketEntriesSettingsActions = {
  createOtherDocketEntriesSettings: async ({ commit }, value) => {
    commit('setOtherDocketEntriesSettingsLoading', true)

    return axiosRequest.
      post('/admin/site_settings', {
        name: 'other_docket_entry',
        value,
      }).
      then(({ data }) => {
        commit('setOtherDocketEntriesSettings', data)
        return data
      }).
      catch(handleError).
      finally(_ => commit('setOtherDocketEntriesSettingsLoading', false))
  },

  getOtherDocketEntriesSettings: async ({ commit }) => {
    commit('setOtherDocketEntriesSettingsLoading', true)

    return axiosRequest.
      get('/admin/site_settings/other_docket_entry').
      then(({ data }) => {
        commit('setOtherDocketEntriesSettings', data)
        return data
      }).
      catch(handleError).
      finally(_ => commit('setOtherDocketEntriesSettingsLoading', false))
  },

  updateOtherDocketEntriesSettings: async ({ getters, commit }, value) => {
    commit('setOtherDocketEntriesSettingsLoading', true)

    return axiosRequest.
      put(`/admin/site_settings/${getters.defaultDocketEntriesSettingsId}`, {
        name: 'other_docket_entry',
        value,
      }).
      then(({ data }) => {
        commit('setOtherDocketEntriesSettings', data)
        return data
      }).
      catch(handleError).
      finally(_ => commit('setOtherDocketEntriesSettingsLoading', false))
  },

  deleteOtherDocketEntriesSettings: async ({ getters, commit }) => {
    commit('setOtherDocketEntriesSettingsLoading', true)

    return axiosRequest.
      delete(`/admin/site_settings/${getters.defaultDocketEntriesSettingsId}`).
      then(({ data }) => {
        commit('setOtherDocketEntriesSettings', data)
        return data
      }).
      catch(handleError).
      finally(_ => commit('setOtherDocketEntriesSettingsLoading', false))
  },
}

export const OtherDocketEntriesSettingsMutations = {
  setOtherDocketEntriesSettings: (state, payload) => { state.defaultDocketEntriesSettings = payload },
  setOtherDocketEntriesSettingsLoading: (state, payload) => { state.defaultDocketEntriesSettingsLoading = payload },
  setOtherDocketEntriesSettingsValue: (state, payload) => { state.defaultDocketEntriesSettings.value = payload },
}

export const OtherDocketEntriesSettingsGetters = {
  defaultDocketEntriesSettings: state => state.defaultDocketEntriesSettings,
  defaultDocketEntriesSettingsId: state => state.defaultDocketEntriesSettings?.id,
  defaultDocketEntriesSettingsLoading: state => state.defaultDocketEntriesSettingsLoading,
  defaultDocketEntriesSettingsValue: state => state.defaultDocketEntriesSettings?.value,
}
